export const preloadLivePagesComponents = async () => {
	return (
		await import(
			/* webpackChunkName: "loadable-livePages-preloader" */
			'./livePages-preloader'
		)
	).preloadLivePagesComponents();
};

export const preloadViewPageComponents = async () => {
	return (
		await import(
			/* webpackChunkName: "loadable-viewPage-preloader" */
			'./view-page'
		)
	).preloadViewPage();
};

export const preloadSpaceOverview = async () => {
	(
		await import(/* webpackChunkName: "loadable-preloadersspace-overview" */ './space-overview')
	).preloadSpaceOverview();
};
